<script setup lang="ts">
import { AtomText, SatIconButton } from "@chatfood/design-system";
import { useModalHubStore } from "../modal-hub";
import { css } from "./css";
import type { MobileHeaderProps } from "./props";
import { useCustomerStore } from "#imports";
import { SwitchLanguage } from "~/components/switch-language";

const props = defineProps<MobileHeaderProps>();

const customerStore = useCustomerStore();
const modalHub = useModalHubStore();

const handleAuth = () => {
  modalHub.showAuthManager();
};
</script>

<template>
  <div :class="css()">
    <AtomText
      v-show="props.title"
      type="subtitle"
      color="color-primary"
      data-test="title"
    >
      {{ props.title }}
    </AtomText>
    <div :class="css('actions')">
      <SwitchLanguage v-show="props.showLocale" />
      <div v-show="props.showAuth">
        <SatIconButton
          v-if="!customerStore.isLogged"
          icon-name="user"
          theme="ghost"
          data-test="auth-button"
          @click.prevent="handleAuth"
        />
        <SatIconButton
          v-else
          :route="{ name: 'my-account.profile' }"
          icon-name="user"
          theme="ghost"
          data-test="profile-button"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-background-shell);
  padding: var(--spacing-md);
  position: relative;

  &__actions {
    display: flex;
    gap: var(--spacing-md);
    justify-content: flex-end;
    align-items: center;
    flex: 1;
    min-width: fit-content;
  }
}
</style>
